import React from 'react';
import {
  Dims,
  MeasuredCookieConnectorOwnProps,
} from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { useDebugRerenders } from '@wix/da-hooks/pkg/useDebugRerenders';
import BaseTorpedo from '../BaseTorpedo';
import { ProGalleryContainer, TorpedoProps } from '../types';

export interface Props
  extends TorpedoProps,
    Partial<MeasuredCookieConnectorOwnProps> {
  defaultSize?: {
    desktop: Dims;
    mobile: Dims;
  };
}

function getMeasuredContainer(
  containerFromProps: ProGalleryContainer,
  measuredContainer?: ProGalleryContainer
) {
  return {
    width: Number(measuredContainer?.width ?? containerFromProps.width),
  };
}

const MeasuredTorpedo = (props: Props) => {
  const { ref, dimensions } = useMeasureElementCookie(props.cookieType, {
    cookieDim: 'width',
    defaultSize: props.defaultSize,
  });
  useDebugRerenders('MeasuredTorpedo', {
    ...props,
    dimensions,
  });

  const container: ProGalleryContainer = getMeasuredContainer(
    props.container,
    dimensions
  );

  return (
    <div ref={ref}>
      <BaseTorpedo {...props} container={container} />
    </div>
  );
};
MeasuredTorpedo.displayName = 'MeasuredTorpedo';

export default MeasuredTorpedo;
